import { c as _c } from "react/compiler-runtime";
import type { Actor, AuditEvent, AuditEventDetail } from '@onefootprint/request-types/dashboard';
import CreateOrgApiKey from './components/create-org-api-key';
import CreateOrgRole from './components/create-org-role';
import CreatePlaybook from './components/create-playbook';
import DeactivateOrgRole from './components/deactivate-org-role';
import DecryptOrgApiKey from './components/decrypt-org-api-key';
import EditPlaybook from './components/edit-playbook';
import InviteOrgMember from './components/invite-org-member';
import ManuallyReviewEntity from './components/manually-review-entity';
import PrincipalActor from './components/principal-actor';
import RemoveOrgMember from './components/remove-org-member';
import UpdateOrgApiKeyRole from './components/update-org-api-key-role';
import UpdateOrgApiKeyStatus from './components/update-org-api-key-status';
import UpdateOrgMember from './components/update-org-member';
import UpdateOrgRole from './components/update-org-role';
import UserData from './components/user-data';
const Event = t0 => {
  const $ = _c(73);
  const {
    auditEvent
  } = t0;
  const {
    principal,
    insightEvent,
    detail
  } = auditEvent;
  const {
    kind
  } = detail;
  const hasPrincipalActor = Boolean(principal && insightEvent);
  let t1;
  if ($[0] !== hasPrincipalActor || $[1] !== insightEvent || $[2] !== principal) {
    t1 = hasPrincipalActor && <PrincipalActor principal={principal as Actor} insightEvent={insightEvent} />;
    $[0] = hasPrincipalActor;
    $[1] = insightEvent;
    $[2] = principal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== detail || $[5] !== kind) {
    t2 = (kind === "update_user_data" || kind === "delete_user_data" || kind === "decrypt_user_data") && <UserData detail={detail as AuditEventDetail} />;
    $[4] = detail;
    $[5] = kind;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== detail || $[8] !== hasPrincipalActor || $[9] !== kind) {
    t3 = kind === "create_org_role" && <CreateOrgRole detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[7] = detail;
    $[8] = hasPrincipalActor;
    $[9] = kind;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== detail || $[12] !== hasPrincipalActor || $[13] !== kind) {
    t4 = kind === "update_org_role" && <UpdateOrgRole detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[11] = detail;
    $[12] = hasPrincipalActor;
    $[13] = kind;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== detail || $[16] !== hasPrincipalActor || $[17] !== kind) {
    t5 = kind === "deactivate_org_role" && <DeactivateOrgRole detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[15] = detail;
    $[16] = hasPrincipalActor;
    $[17] = kind;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== detail || $[20] !== hasPrincipalActor || $[21] !== kind) {
    t6 = kind === "invite_org_member" && <InviteOrgMember detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[19] = detail;
    $[20] = hasPrincipalActor;
    $[21] = kind;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== detail || $[24] !== hasPrincipalActor || $[25] !== kind) {
    t7 = kind === "update_org_member" && <UpdateOrgMember detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[23] = detail;
    $[24] = hasPrincipalActor;
    $[25] = kind;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== detail || $[28] !== hasPrincipalActor || $[29] !== kind) {
    t8 = kind === "remove_org_member" && <RemoveOrgMember detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[27] = detail;
    $[28] = hasPrincipalActor;
    $[29] = kind;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== detail || $[32] !== hasPrincipalActor || $[33] !== kind) {
    t9 = kind === "create_org_api_key" && <CreateOrgApiKey detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[31] = detail;
    $[32] = hasPrincipalActor;
    $[33] = kind;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== detail || $[36] !== hasPrincipalActor || $[37] !== kind) {
    t10 = kind === "update_org_api_key_role" && <UpdateOrgApiKeyRole detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[35] = detail;
    $[36] = hasPrincipalActor;
    $[37] = kind;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== detail || $[40] !== hasPrincipalActor || $[41] !== kind) {
    t11 = kind === "decrypt_org_api_key" && <DecryptOrgApiKey detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[39] = detail;
    $[40] = hasPrincipalActor;
    $[41] = kind;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== detail || $[44] !== hasPrincipalActor || $[45] !== kind) {
    t12 = kind === "update_org_api_key_status" && <UpdateOrgApiKeyStatus detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[43] = detail;
    $[44] = hasPrincipalActor;
    $[45] = kind;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== detail || $[48] !== hasPrincipalActor || $[49] !== kind) {
    t13 = kind === "create_playbook" && <CreatePlaybook detail={detail as AuditEventDetail} hasPrincipalActor={hasPrincipalActor} />;
    $[47] = detail;
    $[48] = hasPrincipalActor;
    $[49] = kind;
    $[50] = t13;
  } else {
    t13 = $[50];
  }
  let t14;
  if ($[51] !== detail || $[52] !== kind) {
    t14 = kind === "edit_playbook" && <EditPlaybook detail={detail as AuditEventDetail} hasPrincipalActor={true} />;
    $[51] = detail;
    $[52] = kind;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  let t15;
  if ($[54] !== detail || $[55] !== kind) {
    t15 = kind === "manually_review_entity" && <ManuallyReviewEntity detail={detail as AuditEventDetail} hasPrincipalActor={true} />;
    $[54] = detail;
    $[55] = kind;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  let t16;
  if ($[57] !== t1 || $[58] !== t10 || $[59] !== t11 || $[60] !== t12 || $[61] !== t13 || $[62] !== t14 || $[63] !== t15 || $[64] !== t2 || $[65] !== t3 || $[66] !== t4 || $[67] !== t5 || $[68] !== t6 || $[69] !== t7 || $[70] !== t8 || $[71] !== t9) {
    t16 = <div className="flex gap-1 flex-wrap w-full shrink-0 items-end max-md:wrap-anywhere">{t1}{t2}{" "}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[57] = t1;
    $[58] = t10;
    $[59] = t11;
    $[60] = t12;
    $[61] = t13;
    $[62] = t14;
    $[63] = t15;
    $[64] = t2;
    $[65] = t3;
    $[66] = t4;
    $[67] = t5;
    $[68] = t6;
    $[69] = t7;
    $[70] = t8;
    $[71] = t9;
    $[72] = t16;
  } else {
    t16 = $[72];
  }
  return t16;
};
export default Event;